import * as marietta from '../../..';
import { Dialog } from '../../../core/view';
import { CONTROL_ACTIONMODE } from '../../Constants';

/**
 * 屋根ー入力方法の説明
 */
class RoofGuidance extends Dialog {
  /**
     * コンストラクタ
     */
  constructor(draggable: boolean) {
    super(draggable);

    const self = this;

    const id = 'dialogRoof';
    let title = '';
    // タイトル
    switch (marietta.webcad.WebCADGlobal.language) {
      case 'en': title = 'Draw the roof line'; break;
      default: title = '屋根の桁線入力'; break;
    }

    const descImg1 = new Image();
    const descImg2 = new Image();
    descImg1.src = `${marietta.webcad.WebCADGlobal.webcad2Dmanager.assets_url}description_roof1.jpg`;
    descImg1.addEventListener('load', function firstImageLoad() {
      document.getElementById('descImg1').appendChild(this);
      self.centerDialog();
    });
    descImg2.src = `${marietta.webcad.WebCADGlobal.webcad2Dmanager.assets_url}description_roof2.jpg`;
    descImg2.addEventListener('load', function secondImageLoad() {
      document.getElementById('descImg2').appendChild(this);
      self.centerDialog();
    });

    let contents = '';
    // 説明画面
    contents += '<div class="roofGuidance">\n';
    contents += '<ol>\n';
    contents += '<li>\n';
    contents += '<div class="title"><span class="jp">1） 屋根の桁線を入力してください。</span><span class="en">Input the roof lines as below on each floor.</span></div>\n';
    contents += '<div class="descImg" id="descImg1">\n';
    contents += '</div>\n';
    contents += '<div class="subTitle"><span class="jp">※入力中に1点戻りたい場合は、「ESC」キー</span><span class="en">Press the ESC key to cancel your most recent input.</span></div>\n';
    contents += '</li>\n';
    contents += '</ol>\n';
    contents += '<ol>\n';
    contents += '<li>\n';
    contents += '<div class="title"><span class="jp">2） 頂点入力後、屋根タイプを選択します。</span><span class="en">Then select the roof type.</span></div>\n';
    contents += '<div class="descImg" id="descImg2">\n';
    contents += '</div>\n';
    contents += '</li>\n';
    contents += '</ol>\n';
    contents += '</div>\n';

    let footer = '';
    footer += '<button id="btnDialogRoofInput"><span class="jp">入力する</span><span class="en">Input</span></button>\n';
    footer += '<button id="btnDialogRoofCancel"><span class="jp">キャンセル</span><span class="en">Cancel</span></button>\n';

    this.createDialog(id, title, contents, footer);

    document.getElementById('btnDialogRoofInput').addEventListener('click', self.startInputRoof);
    document.getElementById('btnDialogRoofCancel').addEventListener('click', self.close);
  }

    /**
     * 頂点入力を開始する
     */
    startInputRoof = () => {
      marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode = CONTROL_ACTIONMODE.ACTIONMODE_INPUT_POINT_ROOF;
      // 閉じる
      this.close();
    }
}

export default RoofGuidance;
